module.exports = __webpack_public_path__ + "img/GoTop.d649822.png";